import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthBrandPanel from "components/Auth/AuthBrandPanel";
import verificationMailIcon from "assets/images/auth/verification-mail.svg";
import arrowLeftIcon from "assets/images/auth/arrow-left.svg";
import { validateOTP } from "utils/authApi";
import "styles/auth.css";

function VerifyEmail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const started = useRef(false);
  const [status, setStatus] = useState("Verifying your email...");
  const [error, setError] = useState("");

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const emailAddress = searchParams.get("email");
    const emailOTP = searchParams.get("token") || searchParams.get("otp");
    if (!emailAddress || !emailOTP) {
      setError(
        "This verification link is invalid or incomplete. If you recently signed up, please enter your verification code."
      );
      return;
    }

    validateOTP(
      { emailAddress, emailOTP },
      "login/validateOTP",
      (verificationData) => {
        if (!verificationData.Result_Status) {
          setError(
            verificationData.Result_Message || "Email verification failed."
          );
          return;
        }

        setStatus("Email verified. Redirecting to account setup...");
        navigate(`/wizard/${verificationData.Result_Output._id}`, {
          replace: true,
        });
      },
      dispatch
    );
  }, [dispatch, navigate, searchParams]);

  return (
    <main className="auth-page auth-page--email-verification">
      <AuthBrandPanel />
      <section className="auth-panel auth-panel--email-verification">
        <div className="auth-email-verification auth-email-verification--result">
          <div className="auth-email-verification__icon">
            <img src={verificationMailIcon} alt="" />
          </div>
          <header className="auth-email-verification__title">
            <h2>{error ? "Verification failed" : "Verify your email"}</h2>
            <p>{error || status}</p>
          </header>
          {error && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Link
                className="auth-email-verification__back"
                to="/authentication/sign-up"
              >
                Go to verification page
              </Link>
              <Link className="auth-email-verification__back" to="/login">
                <img src={arrowLeftIcon} alt="" />
                Back to sign in
              </Link>
            </div>
          )}
        </div>
        <footer className="auth-legal">
          <a href="#privacy">Privacy</a>
          <span>·</span>
          <a href="#terms">Terms</a>
        </footer>
      </section>
    </main>
  );
}

export default VerifyEmail;
